import Vue from 'vue'
import Vuelidate from 'vuelidate'
import Notifications from 'vue-notification'
import vSelect from 'vue-select'
import Paginate from 'vuejs-paginate'
const VueInputMask = require('vue-inputmask').default
import VModal from 'vue-js-modal'
import VTooltip from 'v-tooltip'
import DatePicker from 'vue2-datepicker'
import VueClip from 'vue-clip'

import DefaultLayout from './layouts/Default'
import WelcomeLayout from './layouts/Welcome'

DatePicker.locale('en')

Vue.component('default', DefaultLayout)
Vue.component('welcome', WelcomeLayout)
Vue.component('v-select', vSelect)
Vue.component('paginate', Paginate)
Vue.component('DatePicker', DatePicker)

Vue.use(Vuelidate)
Vue.use(Notifications)
Vue.use(VueInputMask)
Vue.use(VModal)
Vue.use(VTooltip, {
  defaultHtml: false,
})
Vue.use(VueClip)
